import { render, staticRenderFns } from "./ViewDocuments.vue?vue&type=template&id=1fe4a480"
import script from "./ViewDocuments.vue?vue&type=script&lang=ts"
export * from "./ViewDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports